export default __webpack_public_path__ + "static/media/BecomeAnAuthorImg.02703848.png";